import config from '../../configs/config';
import appPath from '../../misc/appPath';
import Blocklink from '../elements/Blocklink';
import TopBar from '../elements/TopBar/TopBar';
import request from 'axios';
import React from 'react';
import {connect} from 'react-redux';
import Screen from './Screen';
import Scrollable from '../elements/Scrollable';
import SandboxedContent from '../SandboxedContent/SandboxedContent';

class PrivacyStatementScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: 'Loading...'
        };
    }
    componentDidMount() {
        this.state.mounted = true;
        request({
            url: appPath('docs/' + this.props.locale + '_privacypolicy.html'),
            method: 'GET'
        })
            .then((response) => {
                if (this.state.mounted) {
                    let content = response.data.replace(/^.*\<body\>/im, '').replace(/\<\/body\>.*$/im, '');
                    this.setState({content});
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    render() {
        var {
                i18n
            } = this.props,
            header = <div>
                <TopBar returnURL="/"></TopBar>
                <hr/>
                <h1>{i18n['label.PrivacyPolicy.title']}</h1>
            </div>;

        return <Screen header={header}>
            <Scrollable>
                <SandboxedContent content={this.state.content} fitHeightToContents="fitHeightToContents"/>
            </Scrollable>
        </Screen>;
    }
};

export default connect(function(state, props) {
    return Object.assign({}, props, {
        i18n: state.i18n.translations,
        locale: state.i18n.locale
    });
})(PrivacyStatementScreen);
